// Commercial (a store's sales rep — not a user account) form schema.
export const commercialForm = [
  { type: "text", label: "Last name", name: "lastName", required: true },
  { type: "text", label: "First name", name: "firstName", required: true },
  { type: "text", label: "Phone number", name: "phoneNumber", required: true },
  { type: "email", label: "Email", name: "email" },
];
